import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isString from 'lodash/isString';
import { getVenues_venues_availabilities } from '../Scenes/StoreListing/__queries__';

export function getBoundariesFromAvailability(
  availability: getVenues_venues_availabilities | undefined | null,
  selectedTime?: string,
) {
  if (!availability) {
    return 'Store.Closed';
  }

  dayjs.extend(utc);
  const { timeRange } = availability;
  const { start, end } = timeRange;

  const selectedDate = selectedTime && selectedTime === 'ASAP' ? dayjs() : dayjs(selectedTime);

  let from = selectedDate
    .utc()
    .set('hour', Number(start.split(':')[0]))
    .set('minute', Number(start.split(':')[1]))
    .local();

  let to = selectedDate
    .utc()
    .set('hour', Number(end.split(':')[0]))
    .set('minute', Number(end.split(':')[1]))
    .local();

  // for nighttime 00:00 - 05:00
  if (from.isAfter(selectedDate) && isNight(selectedDate.hour())) {
    from = from.subtract(1, 'day');
  }
  // for nighttime 00:00 - 05:00
  if (to.isBefore(from)) {
    to = to.add(1, 'day');
  }

  return {
    from,
    to,
  };
}

export function openingHoursFormatTime(
  availabilities: getVenues_venues_availabilities | undefined | null,
) {
  const ranges = getBoundariesFromAvailability(availabilities);

  if (isString(ranges)) {
    return ranges;
  }

  return `${ranges.from.format('HH:mm')} - ${ranges.to.format('HH:mm')}`;
}

// for nighttime 00:00 - 05:00
export function isNight(hours: number) {
  return hours >= 0 && hours < 5;
}

export default openingHoursFormatTime;
